import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button } from "./Button";
import { Icon } from "./Icon";
import { ModalContainer } from "./ModalContainer";
import { Text } from "./Text";
import { View } from "./View";
import { useI18n } from "../lib/i18n";
import { Shadow } from "../styles";
/**
 * Modal view that is used to ask the user to confirm an action. This is
 * typically used when a user is taking a dangerous/destructive action that
 * is difficult to undo.
 *
 * Has various props to allow customizing CTAs and specific messaging
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-76}
 */ export function ConfirmationModal(props) {
    var $t = useI18n().$t;
    var _props_cancelText;
    var cancelText = (_props_cancelText = props.cancelText) !== null && _props_cancelText !== void 0 ? _props_cancelText : $t({
        id: 'ConfirmationModal_cancelButton',
        defaultMessage: 'Cancel'
    });
    var _props_confirmText;
    var confirmText = (_props_confirmText = props.confirmText) !== null && _props_confirmText !== void 0 ? _props_confirmText : $t({
        id: 'ConfirmationModal_confirmButton',
        defaultMessage: 'OK'
    });
    return /*#__PURE__*/ _jsxs(ModalContainer, {
        visible: props.visible,
        onRequestClose: function() {},
        style: [
            {
                width: '90%',
                maxWidth: 400,
                backgroundColor: 'white',
                marginHorizontal: 10,
                borderRadius: 20,
                paddingVertical: 26,
                paddingHorizontal: 24
            },
            Shadow.high
        ],
        children: [
            props.preTitle,
            props.showCloseIcon && !!props.onCancel ? /*#__PURE__*/ _jsxs(View, {
                row: true,
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        text: props.title,
                        size: 21,
                        weight: "bold",
                        textAlign: "center"
                    }),
                    /*#__PURE__*/ _jsx(Icon, {
                        name: "close",
                        onPress: props.onCancel,
                        size: 14,
                        style: {
                            marginLeft: 'auto'
                        },
                        "aria-label": $t({
                            id: 'ConfirmationModal_closeButtonAccessibilityLabel',
                            defaultMessage: 'Close modal'
                        })
                    })
                ]
            }) : /*#__PURE__*/ _jsx(Text, {
                text: props.title,
                size: 21,
                weight: "bold",
                textAlign: "center"
            }),
            typeof props.description === 'string' ? /*#__PURE__*/ _jsx(Text, {
                text: props.description,
                textAlign: 'center',
                style: [
                    props.textStyle,
                    {
                        marginTop: 16
                    }
                ]
            }) : props.description ? /*#__PURE__*/ _jsx(View, {
                style: {
                    marginTop: 16
                },
                children: props.description
            }) : null,
            props.children,
            /*#__PURE__*/ _jsx(View, {
                row: true,
                style: {
                    justifyContent: !!props.onCancel ? 'space-between' : 'center',
                    marginTop: 32
                },
                children: props.actions ? props.actions : /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        !!props.onCancel && /*#__PURE__*/ _jsx(Button, {
                            onPress: props.onCancel,
                            "aria-label": cancelText,
                            text: cancelText,
                            variant: "text",
                            testID: props.cancelTestID
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            onPress: props.onConfirm,
                            "aria-label": confirmText,
                            text: confirmText,
                            variant: "solid",
                            testID: props.confirmTestID
                        })
                    ]
                })
            })
        ]
    });
}
